import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-acesso-com-registro',
  templateUrl: './acesso-com-registro.component.html',
  styleUrls: ['./acesso-com-registro.component.css']
})
export class AcessoComRegistroComponent implements OnInit {

  mensagemErro : string;
  public renovaPermitido: boolean;
  constructor(private router: Router, private messageService: MessageService) { 

  }

  ngOnInit() {

  }
  public navegaRenovarRegistro(){
    this.router.navigate(['/renovar']);
  }

}
